export default {"src":"/_next/static/media/profileGrey.1cbc4c0d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};